import { LexicalEditor, $getSelection, $isRangeSelection, $createParagraphNode } from "lexical";
import { $isTableSelection } from '@lexical/table'
import DropDown, { DropDownItem } from "../../ui/DropDown";
import { dropDownActiveClass } from "./ToolbarPluginUtils";
import { blockTypeToBlockName } from "./constants";
import { $setBlocksType } from '@lexical/selection';
import {
   INSERT_ORDERED_LIST_COMMAND,
   INSERT_UNORDERED_LIST_COMMAND,
   REMOVE_LIST_COMMAND,
} from '@lexical/list';

export default function ToolbarBlockFormatDropDown({
   editor,
   blockType,
   disabled = false,
}: {
   blockType: keyof typeof blockTypeToBlockName;
   editor: LexicalEditor;
   disabled?: boolean;
}): JSX.Element {
   const formatParagraph = () => {
      if (blockType !== 'paragraph') {
         editor.update(() => {
            const selection = $getSelection();
            if (
               $isRangeSelection(selection) ||
               $isTableSelection(selection)
            )
               $setBlocksType(selection, () => $createParagraphNode());
         });
      }
   };


   // const formatHeading = (e: React.MouseEvent<HTMLElement>) => {
   //    const headingSize = e.currentTarget.getAttribute("data-id")
   //    if (headingSize) {
   //       if (blockType !== headingSize) {
   //          editor.update(() => {
   //             const selection = $getSelection();
   //             if (
   //                $isRangeSelection(selection) ||
   //                $isTableSelection(selection)
   //             ) {
   //                $setBlocksType(selection, () =>
   //                   $createHeadingNode(headingSize as HeadingTagType),
   //                );
   //             }
   //          });
   //       }
   //    }

   // };

   const formatBulletList = () => {
      if (blockType !== 'bullet') {
         editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined);
      } else {
         editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
      }
   };

   // const formatCheckList = () => {
   //    if (blockType !== 'check') {
   //       editor.dispatchCommand(INSERT_CHECK_LIST_COMMAND, undefined);
   //    } else {
   //       editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
   //    }
   // };

   const formatNumberedList = () => {
      if (blockType !== 'number') {
         editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined);
      } else {
         editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
      }
   };

   return (
      <DropDown
         disabled={disabled}
         buttonClassName="toolbar-item block-controls"
         buttonIconClassName={'icon block-type ' + blockType}
         buttonLabel={blockTypeToBlockName[blockType]}
         buttonAriaLabel="Formatting options for text style">
         <DropDownItem
            className={'item ' + dropDownActiveClass(blockType === 'paragraph')}
            onClick={formatParagraph}>
            <i className="icon paragraph" />
            <span className="text">Normal</span>
         </DropDownItem>
         {/* <DropDownItem
            className={'item ' + dropDownActiveClass(blockType === 'h1')}
            dataId="h1"
            onClick={formatHeading}>
            <i className="icon h1" />
            <span className="text">Heading 1</span>
         </DropDownItem>
         <DropDownItem
            className={'item ' + dropDownActiveClass(blockType === 'h2')}
            dataId="h2"
            onClick={formatHeading}>
            <i className="icon h2" />
            <span className="text">Heading 2</span>
         </DropDownItem>
         <DropDownItem
            className={'item ' + dropDownActiveClass(blockType === 'h3')}
            dataId="h3"
            onClick={formatHeading}>
            <i className="icon h3" />
            <span className="text">Heading 3</span>
         </DropDownItem> */}
         <DropDownItem
            className={'item ' + dropDownActiveClass(blockType === 'bullet')}
            onClick={formatBulletList}>
            <i className="icon bullet-list" />
            <span className="text">Bullet List</span>
         </DropDownItem>
         <DropDownItem
            className={'item ' + dropDownActiveClass(blockType === 'number')}
            onClick={formatNumberedList}>
            <i className="icon numbered-list" />
            <span className="text">Numbered List</span>
         </DropDownItem>
         {/* <DropDownItem
            className={'item ' + dropDownActiveClass(blockType === 'check')}
            onClick={formatCheckList}>
            <i className="icon check-list" />
            <span className="text">Check List</span>
         </DropDownItem> */}
      </DropDown>
   );
}